import React from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  Row,
} from 'reactstrap';
import ReactDatetime from 'react-datetime';
import moment from 'moment';

import { selectAllOnFocus } from '../../../../helpers/selectOnFocus';
interface BonusesModalProps {
  isOpen: boolean;
  toggle: () => void;
  employees: any[];
  bonusesStaff: string;
  setBonusesStaff: (value: string) => void;
  bonusesReason: string;
  setBonusesReason: (value: string) => void;
  bonusesAmount: string;
  setBonusesAmount: (value: string) => void;
  bonusesDateItBecomesEffectiveOn: string;
  setBonusesDateItBecomesEffectiveOn: (value: string) => void;
  bonusesNumberOfPayments: string;
  setBonusesNumberOfPayments: (value: string) => void;
  handleSubmitBonuses: (event: React.FormEvent) => Promise<void>;
}

const BonusesModal = ({
  isOpen,
  toggle,
  employees,
  bonusesStaff,
  setBonusesStaff,
  bonusesReason,
  setBonusesReason,
  bonusesAmount,
  setBonusesAmount,
  bonusesDateItBecomesEffectiveOn,
  setBonusesDateItBecomesEffectiveOn,
  bonusesNumberOfPayments,
  setBonusesNumberOfPayments,
  handleSubmitBonuses,
}: BonusesModalProps) => {
  const parsedAmount = parseFloat(String(bonusesAmount).replace('$', '')) || 0;
  const parsedPayments = parseInt(bonusesNumberOfPayments, 10) || 0;
  const amountPerPayment = parsedPayments > 1 ? parsedAmount / parsedPayments : 0;

  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen} toggle={toggle} size={'xl'}>
      <div className="modal-header">
        <h4 className="modal-title">Request a Bonuses</h4>
        <div onClick={toggle} className="d-flex p-1 cursor-pointer">
          <i className="fas fa-times" />
        </div>
      </div>
      <div className="modal-body">
        <div className="px-2">
          <Form onSubmit={handleSubmitBonuses}>
            <Row>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Name</label>
                  <Input type="select" value={bonusesStaff} required onChange={(e) => setBonusesStaff(e.target.value)}>
                    <option value=""></option>
                    {employees?.map((value: any, index: number) => {
                      return (
                        <option value={value.user.id} key={`codes-${index}`}>
                          {value.user.firstName} {value.user.lastName}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Reason</label>
                  <Input
                    type="select"
                    value={bonusesReason}
                    required
                    onChange={(e) => setBonusesReason(e.target.value)}
                  >
                    <option value=""></option>
                    <option value="Monthly Bonus">Monthly Bonus</option>
                    <option value="Referral Bonus">Referral Bonus</option>
                    <option value="Annual Bonus">Annual Bonus</option>
                    <option value="Sign On Bonus">Sign On Bonus</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <label className="form-control-label">$ Amount</label>
                <Input
                  type="text"
                  value={bonusesAmount}
                  required
                  onChange={(event) => {
                    const numbers = event.target.value.replace(/[^\d]/g, '');
                    const amount = (parseFloat(numbers) / 100).toLocaleString('en-IN', {
                      style: 'currency',
                      currency: 'USD',
                    });
                    setBonusesAmount(String(amount).replaceAll(',', ''));
                  }}
                />
              </Col>

              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Date It Becomes Effective On</label>
                  <InputGroup className="input-group-alternative">
                    <ReactDatetime
                      inputProps={{
                        placeholder: 'Start Date',
                      }}
                      onChange={(newValue) => {
                        setBonusesDateItBecomesEffectiveOn(`${newValue}`);
                      }}
                      timeFormat={false}
                      value={`${moment(bonusesDateItBecomesEffectiveOn).format('MM/DD/yyyy')}`}
                      dateFormat={'MM/DD/yyyy'}
                      closeOnSelect={true}
                    />
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-calendar-grid-58" />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Number of Payments (split)</label>
                  <Input
                    type="number"
                    {...selectAllOnFocus}
                    min={1}
                    placeholder="1 = single payment"
                    value={bonusesNumberOfPayments}
                    onChange={(e) => setBonusesNumberOfPayments(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Amount Per Paycheck</label>
                  <Input
                    type="text"
                    disabled
                    placeholder="Single payment"
                    value={amountPerPayment > 0 ? `$ ${amountPerPayment.toFixed(2)}` : ''}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex justify-content-around mt-4">
              <Button className="btn-secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button style={{ background: '#02c412', color: '#FFFFFF', width: '150px' }}>Save</Button>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default BonusesModal;
